import { motion } from "framer-motion";

/**
 * ChatHeader — small uppercase tracked label que abre cada DataCard premium.
 *
 * Props:
 *   label   — texto principal (ex: "TAREFAS", "AGENDA · QUARTA-FEIRA")
 *   count   — texto secundário opcional (ex: "3 ITENS", "2 PENDENTES")
 *   meta    — texto à direita opcional (data, hora, etc.)
 *
 * Visual: micro-text 11px, slate-500, tracking 0.1em uppercase.
 */
export default function ChatHeader({ label, count, meta }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -2 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className="flex items-baseline justify-between mb-2"
      data-testid="ds-chat-header"
    >
      <p className="text-[11px] tracking-[0.1em] uppercase text-slate-500 font-medium">
        {label}
        {count ? <span className="text-slate-600"> · </span> : null}
        {count ? <span className="text-slate-400">{count}</span> : null}
      </p>
      {meta ? (
        <span className="text-[11px] tracking-wide text-slate-500">{meta}</span>
      ) : null}
    </motion.div>
  );
}
